import React from "react";
import LoadingSpinnerWebView from "@/components/webview/icon/loadingSpinnerWebView";

const GlobalLoadingWebView = () => {
  return (
    <div className="absolute inset-0 z-[9999] flex items-center justify-center bg-black/55">
      <LoadingSpinnerWebView className="animate-spin text-white" />
    </div>
  );
};

export default GlobalLoadingWebView;
